import nls from '../es/Timeout.js';
export default {
  ...nls,
};
